// extracted by mini-css-extract-plugin
module.exports = {"ScreenLoader":"styles_ScreenLoader__rnzp5","ScreenLoader__Title":"styles_ScreenLoader__Title__10Zae"};